import { useCallback, useEffect, useRef, useState } from 'react';

export const SEARCH_INPUT_SYNC_DELAY_MS = 80;

export const useBufferedSearchInput = (
  value: string,
  onSync: (value: string) => void,
) => {
  const [draftInput, setDraftInput] = useState(value);
  const syncTimerRef = useRef<number | null>(null);
  const onSyncRef = useRef(onSync);

  useEffect(() => {
    onSyncRef.current = onSync;
  }, [onSync]);

  useEffect(() => {
    setDraftInput(value);
  }, [value]);

  const cancelPendingSync = useCallback(() => {
    if (syncTimerRef.current === null) return;
    window.clearTimeout(syncTimerRef.current);
    syncTimerRef.current = null;
  }, []);

  const updateDraftInput = useCallback((nextValue: string) => {
    setDraftInput(nextValue);
    cancelPendingSync();
    syncTimerRef.current = window.setTimeout(() => {
      syncTimerRef.current = null;
      onSyncRef.current(nextValue);
    }, SEARCH_INPUT_SYNC_DELAY_MS);
  }, [cancelPendingSync]);

  useEffect(() => cancelPendingSync, [cancelPendingSync]);

  return {
    draftInput,
    updateDraftInput,
    cancelPendingSync,
  };
};
